<template>
  <div>
        <v-container fluid>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
       <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

       <v-card class="box">
       <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Add Inventory Material</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
       <v-row justify="center" dense>
                <v-col cols="12" sm="3">
                    <p><b>Name*</b></p>
                    <v-text-field  outlined dense type="text" v-model="name" ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                    <p><b>Code*</b></p>
                     <v-text-field  outlined dense type="text" v-model="code" ></v-text-field>
                </v-col>
            </v-row>
              <v-row justify="center" dense>
                  <v-col cols="12" sm="3">
                    <p><b>Material Type*</b></p>
                       <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="inv_material_type"
                        :items="inv_material_type_list"
                        item-text="name"
                        item-value="id"
                        label="Material Type"
                        outlined
                        />
                </v-col>
                 <v-col cols="12" sm="3">
                    <p><b>Material Category*</b></p>
                       <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="inv_material_category"
                        :items="inv_material_category_list"
                        item-text="name"
                        item-value="id"
                        label="Material Category"
                        outlined
                        />
                </v-col>
                <v-col cols="12" sm="3">
                    <p><b>Material Set*</b></p>
                       <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="inv_material_set"
                        :items="inv_material_set_list"
                        item-text="name"
                        item-value="id"
                        label="Material Set"
                        outlined
                        />
                </v-col>
              </v-row>
               <v-row justify="center" dense v-if="name && code && inv_material_set && inv_material_category && inv_material_type">
          <v-btn color="warning" @click="saveInventoryMaterial()" :loading="loader"
            >Add</v-btn
          >
        </v-row>
       </v-card>

     <v-card class="box" v-if="inventory_material_list!='' ">
     <v-data-table  :headers="headers" :items="inventory_material_list" :items-per-page="-1">
        <template v-slot:top>
            <v-toolbar flat class="toolbar">
                <v-toolbar-title>Inventory Material List</v-toolbar-title>
                <v-divider class="mx-4" inset vertical ></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
        </template>
         <template v-slot:[`item.isactive`]="{ item }">
                 <v-switch v-model="item.isactive"  @change="toggleIsactive(item)"></v-switch>
      </template>
       <template v-slot:[`item.delete`]="{ item }">
            <v-avatar size="35">
              <v-icon
                class="mr-4 v-icon-size"
                color="red"
                @click="deleteInventoryMaterial(item)"
                >mdi-trash-can</v-icon
              >
            </v-avatar>
          </template>
          <template v-slot:[`item.edit`]="{ item }">
            <v-avatar size="35">
              <v-icon
                class="mr-4 v-icon-size"
                color="red"
                @click="editDetail(item)"
                >mdi-pencil</v-icon
              >
            </v-avatar>
          </template>
     </v-data-table>
 </v-card>

         <v-dialog
        v-model="dialog_edit"
        persistent
        scrollable="false"
        max-width="1200px"
        transition="dialog-bottom-transition"
      >
        <v-card class="box">
          <v-toolbar flat class="toolbar">
            <v-toolbar-title>Edit Inventory Material</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-row justify="center" dense>
               <v-col cols="12" sm="3">
                <p><b>Name</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="editedItem.name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <p><b>Code</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="editedItem.code"
                ></v-text-field>
              </v-col>
            <v-col cols="12" sm="3">
            <p><b>Material Category</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="editedItem.invmaterialcategory"
              :items="inv_material_category_list"
              item-text="name"
              item-value="id"
              label="Material Category"
              outlined
            />
          </v-col>
          <v-col cols="12" sm="3">
            <p><b>Material Type</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="editedItem.invmaterialtype"
              :items="inv_material_type_list"
              item-text="name"
              item-value="id"
              label="Material Type"
              outlined
            />
          </v-col>
           <v-col cols="12" sm="3">
            <p><b>Material Set</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="editedItem.invmaterialset"
              :items="inv_material_set_list"
              item-text="name"
              item-value="id"
              label="Material Set"
              outlined
            />
          </v-col>
            </v-row>
          </v-card-text>
          <br />
          <v-row justify="center">
            <v-btn color="primary" :loading="loader" @click="saveUpdateInventoryMaterial()"
              >Update</v-btn
            >
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" @click="dialog_edit = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

        </v-container>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
      loader:false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      overlay: false,
      name:"",
      code:"",
      inventory_material_list:[],inv_material_type:"",inv_material_category:"",inv_material_set:"",
      inv_material_category_list:[],
      inv_material_set_list:[],
      inv_material_type_list:[],
      headers:[
      { text: "Name", value: "name" },
      { text: "Code", value: "code" },
      { text: "Material Type", value: "invmaterialtype" },
      { text: "Material Category", value: "invmaterialcategory" },
      { text: "Material Set", value: "invmaterialset" },
      { text: "Isactive", value: "isactive" },
      { text: "Edit", value: "edit" },
      { text: "Delete", value: "delete" },
      ],
    dialog_edit: false,
    editedItem: {
      id: "",name: "",code:"",invmaterialtype:"",invmaterialcategory:"",invmaterialset:""
    },
  }),
   methods: {
    
      clearData(){
        this.name="",this.code="",this.inv_material_category="",this.inv_material_set="",this.inv_material_type=""
      },
      async saveUpdateInventoryMaterial(){
       this.overlay = true;
       this.loader = true;
        try {
          const res = await axios.post("/Inventory/saveUpdateInventoryMaterial", this.editedItem);
          if (res.data.flag == "YES") {
            this.inventory_material_list=res.data.inventory_material_list
            this.showSnackbar("green", "Updated Successfully"); // show snackbar  
          }
           if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar               
           }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
         this.loader = false;
         this.overlay = false;
         this.dialog_edit = false;
      }
    },
    editDetail(item) {
      this.editedItem.id = item.id;
      this.editedItem.code = item.code;
      this.editedItem.name = item.name;
      this.editedItem.invmaterialtype = item.invmaterialtype_id;
      this.editedItem.invmaterialcategory = item.invmaterialcategory_id;
      this.editedItem.invmaterialset = item.invmaterialset_id;
      this.dialog_edit = true;
    },
    async saveInventoryMaterial(){
        const data = {
        name:this.name,
        code:this.code,
        inv_material_type:this.inv_material_type,
        inv_material_category:this.inv_material_category,
        inv_material_set:this.inv_material_set,
      };
      this.overlay = true;
      this.loader = true;
        try {
          const res = await axios.post("/Inventory/saveInventoryMaterial", data);
          if (res.data.flag == "YES") {
            this.inventory_material_list=res.data.inventory_material_list
            this.showSnackbar("green", "Saved Successfully"); // show snackbar   
            this.clearData();
          }
           if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar               
           }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
         this.loader = false;
         this.overlay = false;
      }
    },
     async toggleIsactive(item){
        const data = {
            id: item.id,
            isactive: item.isactive,
      };
      this.overlay = true;
      this.loader = true;
        try {
          const res = await axios.post("/Inventory/toggleIsactiveMaterial", data);
          if (res.data.flag == "YES") {
            this.inventory_material_list=res.data.inventory_material_list
            this.showSnackbar("green", "Updated Successfully"); // show snackbar    
          }
           if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar               
           }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
         this.loader = false;
         this.overlay = false;
      }
    },
     async deleteInventoryMaterial(item){
       if (!confirm("Are You Sure You Want To Delete This Item?"))
        return;
        const data = {
            id: item.id,
      };
      this.overlay = true;
      this.loader = true;
        try {
          const res = await axios.post("/Inventory/deleteInventoryMaterial", data);
          if (res.data.flag == "YES") {
            this.inventory_material_list=res.data.inventory_material_list
          }
           if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar               
           }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
         this.loader = false;
         this.overlay = false;
      }
    },
    async onLoad() {
      try {
          const res = await axios.post("/Inventory/getInventoryMaterialList");
          if (res.data.flag == "YES") {
            this.inventory_material_list=res.data.inventory_material_list
            this.inv_material_type_list=res.data.inv_material_type_list
            this.inv_material_category_list=res.data.inv_material_category_list
            this.inv_material_set_list=res.data.inv_material_set_list
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
        this.save_loader = false;
      }
     
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
   mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
</style>